export const DeviceBreakpoint = {
    phone: 422,
    tablet: 768,
    laptop: 1080,
    desktop: 1366,
};
export default Object.freeze(DeviceBreakpoint);
